import React from 'react';
import {AdvancedMarker} from '@vis.gl/react-google-maps';
import styles from './Mapping.module.css';
import {useSelector} from 'react-redux';

const NetOfFreightLocationMarker = ({location}) => {

  const {
    netOfFreightPerMileCost,
    netOfFreightTruckBaseRate,
    netOfFreightSelectedCommodity,
  } = useSelector(state => state.mapping);

  /*
    The cost per bushel of freight/hauling will be determined by an equation of Y = M(x) + B
    Y is the freight cost
    M is the per mile cost
    x is the # of miles calculated
    B is the base rate for the truck

    Constants:
    M = $0.0025
    B = $0.10

    miles = meters × 0.000621371
  */

  const miles = location.directions.routes[0].legs[0].distance.value * 0.000621371;

  const costPerBushel = (parseFloat(netOfFreightPerMileCost) * miles) + parseFloat(netOfFreightTruckBaseRate);

  const cashPrice = location.location.bids[0].cashprice - costPerBushel;

  return (
    <>
      <AdvancedMarker
        position={{
          lng: location.directions.routes[0].legs[0].steps[location.directions.routes[0].legs[0].steps.length - 1].end_location.lng(),
          lat: location.directions.routes[0].legs[0].steps[location.directions.routes[0].legs[0].steps.length - 1].end_location.lat(),
        }}
        key={location.location.locationId}>
        <div className={styles.netOfFreightScoreboard}>
          <div className={styles.netOfFreightScoreboardName}>{location.location.location}</div>
          <div className={styles.netOfFreightScoreboardBr}></div>
          <div className={styles.netOfFreightScoreboardDataDiv}>
            <div>{location.directions.routes[0].legs[0].distance.text}</div>
          </div>
          <div className={styles.netOfFreightScoreboardDataDiv}>
            <div>{netOfFreightSelectedCommodity}</div>
          </div>
          <div className={styles.netOfFreightScoreboardDataDiv}>
            <div>{'$' + costPerBushel.toLocaleString('en-US', {style: 'decimal', maximumFractionDigits: 2, minimumFractionDigits: 2,})}</div>
            <div>{'Freight Cost per Bushel'}</div>
          </div>
          <div className={styles.netOfFreightScoreboardDataDiv}>
            <div>{'$' + cashPrice.toLocaleString('en-US', {style: 'decimal', maximumFractionDigits: 2, minimumFractionDigits: 2,})}</div>
            <div>{'Cash Price Net of Freight'}</div>
          </div>
          <div className={styles.netOfFreightScoreboardArrow}></div>
        </div>
      </AdvancedMarker>
    </>
  );
};

export default NetOfFreightLocationMarker;